// extracted by mini-css-extract-plugin
module.exports = {"color":"Email_color__tLHlI","margin":"Email_margin__3ag_v"};